// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"37":"5dc7b3aa","64":"2a333aab","350":"977083c2","353":"b0ba5724","492":"04b95587","561":"06deb028","946":"671dafd1","947":"e274a319"}[chunkId] + ".css";
};